/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationItem {
    getFixupPrototypeFunction() { return PromptRecommendationItem.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationItem>): PromptRecommendationItem {
        let obj = Object.assign(new PromptRecommendationItem(), model);
        PromptRecommendationItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationItem>): PromptRecommendationItem {
        if (!model) return null;
        return PromptRecommendationItem.newInstance(<PromptRecommendationItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationItem) {
        if (!obj) return;

        models.PromptRecommendationItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationItem): boolean {
        Object.setPrototypeOf(obj, PromptRecommendationItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_cost_saved === undefined) {
            this.total_cost_saved = 0;
        }
        if (this.prompt_count === undefined) {
            this.prompt_count = 0;
        }
        if (this.high_confidence_prompts === undefined) {
            this.high_confidence_prompts = 0;
        }
    }

    /**
     * Recommendation type: model_switching | caching
     */
    category: string;

    /**
     * Currently deployed model identifier
     */
    model_id: string;

    /**
     * Suggested replacement model identifier
     */
    recommended_model_id: string;

    /**
     * Projected monthly cost saving in USD
     */
    total_cost_saved: number;

    /**
     * Number of prompts with this recommendation
     */
    prompt_count: number;

    /**
     * Number of prompts with this recommendation which has been tagged at high confidence
     */
    high_confidence_prompts: number;

    /**
     * Service account these recommendations belong to
     */
    service_account_id: string;

}
